import React, { Component } from 'react';

const ExampleTags = () =>
  <section id="tags">
    <h3 className="section-header">Tags, Labels & Badges</h3>
    <div className="row">
      <div className="columns medium-15">
        <span className="tag tag-default">Default Tag</span>
        <span className="tag tag-default dismissible">Dismissible Tag <i className="fa fa-times-circle"></i></span>
        <span className="tag tag-highlight">Highlight Tag</span>
        <span className="tag tag-highlight success">Success Tag</span>
        <span className="tag tag-highlight warning">Warning Tag</span>
        <span className="tag tag-highlight danger">Danger Tag</span>
        <br/><br/>
        <span className="tag tag-default tag-sm">Default Tag</span>
        <span className="tag tag-highlight tag-sm">Highlight Tag</span>
        <span className="tag tag-highlight success tag-sm">Success Tag</span>
        <span className="tag tag-highlight warning tag-sm">Warning Tag</span>
        <span className="tag tag-highlight danger tag-sm">Danger Tag</span>
      </div>
    </div>
    <div className="row">
      <div className="columns medium-15">
        <span className="label label-default">default label</span><br/>
        <span className="label label-success">success label</span><br/>
        <span className="label label-warning">warning label</span><br/>
        <span className="label label-danger">danger label</span><br/>
      </div>
      <div className="columns medium-15">
        <span className="label label-default">small label</span><br/>
        <span className="label label-default label-md">medium label</span><br/>
        <span className="label label-default label-lg">large label</span>
      </div>
    </div>
    <div className="row">
      <div className="columns medium-3">
         .badge-sm<span className="badge badge-default badge-sm">5</span><br/>
      </div>
      <div className="columns medium-3">
         .badge<span className="badge badge-default">2</span><br/>
      </div>
      <div className="columns medium-3">
        .badge-md<span className="badge badge-default badge-md">5</span><br/>
      </div>
      <div className="columns medium-3">
        .badge-lg<span className="badge badge-default badge-lg">8</span><br/>
      </div>
    </div>
  </section>;

export { ExampleTags }



// WEBPACK FOOTER //
// ./styleguide/components/tags.jsx